import { render, staticRenderFns } from "./TipoComboNormal.vue?vue&type=template&id=90d033bc&scoped=true&"
import script from "./TipoComboNormal.vue?vue&type=script&lang=js&"
export * from "./TipoComboNormal.vue?vue&type=script&lang=js&"
import style0 from "./TipoComboNormal.vue?vue&type=style&index=0&id=90d033bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d033bc",
  null
  
)

export default component.exports